import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="field-grid-light scroll-mt-4 bg-cream py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gz2sqezjay">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1n9r0rt76bnk0">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-166" data-mp="1s9n7i0799t39">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-gold-500 bg-white shadow-2xl shadow-earth-900/15" data-id="element-167" data-mp="1x9rmflsimfrd">
          <div className="furrow-bar h-2 w-full" aria-hidden="true" data-id="element-168" data-mp="225qjryvtn83x" />
          <div className="p-6 sm:p-10" data-id="element-169" data-mp="2w0in2wvaq3u">
            <span className="inline-flex items-center gap-2 rounded-md bg-forest-800 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-gold-300" data-id="element-170" data-mp="2x1tp7dvvclk">
              <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="1mi99x2rwowj9" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-earth-100 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-172" data-mp="1hon6803q02zl">
              <div data-id="element-173" data-mp="17rs9nmr0ccny">
                <h3 className="text-2xl font-extrabold leading-tight text-forest-950" data-id="element-174" data-mp="17sacj286dp4u">{productShortName}</h3>
                <p className="mt-2 text-sm text-earth-700" data-id="element-175" data-mp="25fsmuhhhizay">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-176" data-mp="1vgbhy2a24pg1">
                <span className="text-sm text-earth-700" data-id="element-177" data-mp="1vj7crhqlyy09">
                  Precio regular: <span className="line-through" data-id="element-178" data-mp="1rfhufa0j1cno">{priceBefore}</span>
                </span>
                <p className="mt-1 flex items-baseline gap-2 sm:justify-end" data-id="element-179" data-mp="k3r4mnt1feda">
                  <span className="text-sm font-bold uppercase text-earth-700" data-id="element-180" data-mp="fzjcegndfgab">Hoy:</span>
                  <span className="font-display text-5xl font-extrabold tracking-tight text-forest-900" data-id="element-181" data-mp="hhhzczxtm8cp">{price}</span>
                </p>
                <p className="mt-2 inline-block rounded-md border border-gold-500 bg-gold-100 px-2.5 py-1 text-xs font-extrabold uppercase tracking-[.14em] text-earth-900" data-id="element-182" data-mp="mg31j4wmv23s">
                  Más del 50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-183" data-mp="3uvw8as15wz7n">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-forest-950" data-id="element-184" data-mp="3is3toqnggqg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-700" aria-hidden="true" data-id="element-185" data-mp="3l01klii30dy0" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-186" data-mp="3byv0z0k4yn0j">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-earth-800" data-id="element-187" data-mp="2xatmx9uzocbp">
              <span className="inline-flex items-center gap-1.5" data-id="element-188" data-mp="2scs3uoxkcd08">
                <LockIcon className="h-4 w-4 text-forest-700" aria-hidden="true" data-id="element-189" data-mp="2secvo6shthue" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-190" data-mp="31cybvvahsks0">
                <ZapIcon className="h-4 w-4 text-forest-700" aria-hidden="true" data-id="element-191" data-mp="31eszxih28t0b" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-192" data-mp="3baw22obwwrn9">
                <ShieldCheckIcon className="h-4 w-4 text-forest-700" aria-hidden="true" data-id="element-193" data-mp="3bam8yrvkm4dc" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-earth-700" data-id="element-194" data-mp="3l0xqxic3ae38">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}